import '@babel/polyfill'; // IE 11 support
import 'url-polyfill'; // IE 11 support
import 'whatwg-fetch'; // IE 11 support
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import * as Sentry from '@sentry/vue';
import store from './store';
import i18n from './i18n';
import sav from './sav/sav';
import router from './router';
import VueUtil from './utils/VueUtil';
import App from './App';

Vue.config.productionTip = false;

Vue.use(Vuelidate);

VueUtil.plugins = {
  Vuelidate,
  router,
  store,
  sav,
  i18n,
};

Sentry.init({
  Vue,
  dsn: 'https://4df0e7b6bead4623bdadcfb4e4f8dce2@monitor.ditoy.dev/1',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
  tracesSampleRate: sav.env === 'development' ? 1 : 0.1,
  environment: sav.env,
  release: sav.version,
});

new Vue({ ...VueUtil.plugins, render: h => h(App) }).$mount('#app');
